// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const _enumValues = <Enum extends Record<string, any>>(
  enumObject: Enum
): Enum[keyof Enum][] => {
  const enumValues = Object.values(enumObject);

  return enumValues;
};
